import {
	Box,
	Toolbar as MuiToolbar,
	Container,
	Grid,
	IconButton,
	Paper,
	Slide,
	styled
} from '@mui/material';
import { Menu, Close } from '@mui/icons-material';
import React from 'react';

const StyledPaper = styled(Paper)(({ theme }) => ({
	zIndex: 2000,
	backgroundColor: '#fff',
	top: 0,
	left: 0,
	position: 'fixed',
	height: 64,
	width: '100%'
}));

const StyledContainer = styled(Container)({
	paddingTop: 10
});

const StyledIconButton = styled(IconButton)({
	marginTop: 4
});

const Toolbar = ({ open, handleClose, children, ...props }) => {
	return (
		<Slide in={open} direction="down">
			<StyledPaper square elevation={2}>
				<StyledContainer maxWidth="xl">
					<Grid container spacing={1}>
						<Grid item xs={1} />
						<Grid item xs={10}>
							<Box sx={{ display: 'flex', mt: 1, justifyContent: 'center' }}>
								{children}
							</Box>
						</Grid>
						<Grid item xs={1}>
							<Box
								sx={{
									display: 'flex',
									width: '100%',
									justifyContent: 'flex-end'
								}}
							>
								<StyledIconButton onClick={handleClose}>
									<Close />
								</StyledIconButton>
							</Box>
						</Grid>
					</Grid>
				</StyledContainer>
			</StyledPaper>
		</Slide>
	);
};

export default Toolbar;
